<template lang="pug">
include /mixins

+b.tt-apps-wrap(v-if='show')
  +b.tt-apps-view
    +b.close-popup--style_light.mdi.mdi-close.A(
      @click.prevent='show = false'
    )
    +e.head
      +e.icon.IMG(
        :src='icon ? icon.icon : ""'
      )
      +e.title.P {{ _('Застосунок для Вашого комфорту') }}
    +e.actions
      +b.g-row
        +b.g-cell.g-cols--6
          +b.tt-button--bordered_grey-v2.A(
            :href='originUrl'
            target='_blank'
            rel='noopener noreferrer'
          )
            +e.title.SPAN {{ _('Відкрити') }}
        +b.g-cell.g-cols--6
          +b.tt-button.A(
            :href='storeLink'
            target='_blank'
          )
            +e.title.SPAN {{ _('Завантажити') }}
</template>

<script>
import {
  setCookie,
  getCookie,
} from '@utils/cookies'

import { getMobileAppIconsResource } from '@api/vendor.service.js'
import { TOTIS_2_DOWNLOAD_APPS_VIEW } from '@/app'

import { getOs, APPLE_AVAILABLE_OS_LIST } from '@/js/firebase/helpers'

// eslint-disable-next-line camelcase
const {
  google_play_app_link: googlePlayAppLink,
  app_store_app_link: appStoreAppLink,
  show_modal_with_apps_links: showModal,
  internal_dynamic_app_link: internalLink,
} = window

const ZERO = 0

export default {
  name: 'MobileAppsView',
  googlePlayAppLink,
  appStoreAppLink,
  data() {
    return {
      icon: null,
      show: false,
    }
  },
  mounted() {
    if (!showModal) return
    if (navigator.maxTouchPoints > ZERO ||
      navigator.msMaxTouchPoints > ZERO) {
      setTimeout(() => {
        this.checkShowModal()
      }, 2000)
    }
  },
  computed: {
    os() {
      return getOs()
    },
    isAppleDevice() {
      return APPLE_AVAILABLE_OS_LIST.includes(this.os)
    },
    storeLink() {
      return this.isAppleDevice
        ? appStoreAppLink
        : googlePlayAppLink
    },
    originUrl() {
      return internalLink
    },
  },
  methods: {
    async checkShowModal() {
      const hasSeenModal = getCookie(TOTIS_2_DOWNLOAD_APPS_VIEW)
      if (hasSeenModal) return

      await this.fetchAppIcons()
      this.show = true
      setCookie(TOTIS_2_DOWNLOAD_APPS_VIEW, 'true')
    },
    async fetchAppIcons() {
      try {
        const response = await getMobileAppIconsResource.execute()
        const [icon] = response.data
        this.icon = icon
      } catch (error) {
        console.error('Error fetching app icons:', error)
      }
    },
  },
}
</script>
